import {
  faPencilAlt,
  faTimesCircle,
  faTrashAlt,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { getCreditCards, profilePostAction } from "../../actions/profileAction";
import ConfirmDialog from "../../components/ConfirmDialog";
import { getUserDetail } from "../../utils/helper";
import CardPopup from "./CardPopup";
import PaymentMethod from "./PaymentMethod";
import {
  acumaticaGetCustomerPaymentMethods,
  acumaticaPostAction,
} from "../../actions/acumaticaAction";
const PaymentMethodProfiles = ({ setActiveCard, closePopup, activeCard }) => {
  const dispatch = useDispatch();
  const cardList = useSelector((state) => state.acumatica.paymentMethods);
  const [selectedCard, setSelectedCard] = useState(activeCard);
  const [editCard, setEditCard] = useState(null);
  const [showConfirmDialog, setShowConfirmDialog] = useState(false);
  const [showEditConfirmDialog, setShowEditConfirmDialog] = useState(false);
  const [showCardModal, setShowCardModal] = useState(false);
  const [listChanged, setListchanged] = useState(false);
  const handleCardChange = (e) => {
    setSelectedCard(cardList.filter((x) => x.MethodID == e.target.value)[0]);
  };
  const handleEditCard = (id) => {
    let Card = cardList.filter((x) => x.MethodID == id)[0];
    setEditCard(Card);
    setShowCardModal(true);
  };

  const handleDeleteCard = (id) => {
    let Card = cardList.filter((x) => x.MethodID == id)[0];
    setEditCard(Card);
    setShowConfirmDialog(true);
  };
  useEffect(() => {
    if (cardList.length > 0) {
      setSelectedCard(activeCard);
    } else {
      setSelectedCard(null);
    }
  }, [cardList]);
  const deleteCard = () => {
    var params = {
      params: {
        action: "deleteEbizchargeCustomerPaymentMethod",
        data: {
          methodId: editCard.MethodID,
          customerId: getUserDetail()?.customerId,
          paymentId: editCard.ID,
        },
        token: getUserDetail()?.token,
      },
    };
    dispatch(
      acumaticaPostAction(params, () => {
        if (activeCard?.MethodID == editCard?.MethodID) {
          setActiveCard(null);
        }
        dispatch(
          acumaticaGetCustomerPaymentMethods(
            getUserDetail()?.customerId,
            () => {
              setListchanged(true);
            }
          )
        );
      })
    );
  };
  useEffect(() => {
    if (listChanged) {
      if (!cardList.some((x) => x.MethodID == activeCard?.MethodID)) {
        setActiveCard(cardList[0]);
      } else {
        setActiveCard(cardList.find((x) => x.MethodID == activeCard?.MethodID));
      }
      setSelectedCard(cardList[0]);
      setListchanged(false);
    }
  }, [listChanged]);

  const creditCards = cardList?.map((x) => (
    <div key={x.MethodID} className="address-item">
      <div className="labels">
        <input
          type="radio"
          name="address"
          value={x.MethodID}
          id={x.MethodID}
          onChange={handleCardChange}
          checked={selectedCard?.MethodID == x.MethodID}
        />
        <label htmlFor={x.MethodID}>
          {x.AccountHolderName} {x.CardNumber} Exp: {x.CardExpiration}
        </label>
      </div>
      <div className="actions">
        <FontAwesomeIcon
          icon={faPencilAlt}
          color="#00a65a"
          onClick={() => handleEditCard(x.MethodID)}
        />
        <FontAwesomeIcon
          icon={faTrashAlt}
          color="#dd4b39"
          onClick={() => handleDeleteCard(x.MethodID)}
        />
      </div>
    </div>
  ));
  return (
    <Modal size="lg" show={true} backdrop="static">
      <Modal.Header>
        <div className="modal-title">
          <h5 className="profile-title">Choose Payment Method</h5>
          <div className="close-btn">
            <FontAwesomeIcon icon={faTimesCircle} onClick={closePopup} />
          </div>
        </div>
      </Modal.Header>{" "}
      {showCardModal && (
        <PaymentMethod
          setListChanged={setListchanged}
          cardInfo={editCard}
          closePopup={() => setShowCardModal(false)}
        />
      )}
      {cardList?.length > 0 && (
        <Modal.Body>
          <>
            {showConfirmDialog && (
              <ConfirmDialog
                title="Are you sure want to delete this payment method?"
                acceptAction={deleteCard}
                acceptText="yes"
                rejectText="no"
                closePopup={() => setShowConfirmDialog(false)}
                note={
                  editCard?.isDefault
                    ? "Note, this payment method is currently being used as default. "
                    : null
                }
              />
            )}
            {showEditConfirmDialog && (
              <ConfirmDialog
                title="Are you sure want to edit this payment method?"
                acceptAction={() => setShowCardModal(true)}
                acceptText="yes"
                rejectText="no"
                closePopup={() => {
                  setShowEditConfirmDialog(false);
                }}
              />
            )}
            {creditCards}
          </>
        </Modal.Body>
      )}
      <div className="address-submit-section ">
        {cardList?.length > 0 && (
          <button
            className="btn-orange mr-4"
            onClick={() => {
              setActiveCard(selectedCard);
              closePopup();
            }}
          >
            Select
          </button>
        )}
        <button
          className="btn-orange"
          onClick={() => {
            setEditCard(null);
            setShowCardModal(true);
          }}
        >
          Add New
        </button>
      </div>
    </Modal>
  );
};
export default PaymentMethodProfiles;
